export const WHATSAPP_DISPLAY = '+1 (323) 385-5169';

export const PROMO_MESSAGE =
  'Hola, vengo de la página de JAM Fragrances y quiero aprovechar la promoción de 3 perfumes por $129.99. Quiero comprar y elegir mis fragancias.';

export const WHATSAPP_LINK = `https://wa.me/message/VC4IHVZZ3IBCB1?text=${encodeURIComponent(PROMO_MESSAGE)}`;

export function productOrderUrl(_productName: string): string {
  return WHATSAPP_LINK;
}

export const GENERAL_ENQUIRY_URL = WHATSAPP_LINK;
export const SPECIFIC_FRAGRANCE_URL = WHATSAPP_LINK;
